<!--
  ~ Copyright (c) 2019. Sonrai Analytics Ltd.
  ~ Developed by Deva Sen. & Warren Dowey
  -->

<div>
  <app-frame [slug]="slug" [projectSlug]="projectSlug" [dashId]="dashId"></app-frame>
</div>
